import React from "react";
import Accord from "../../../assets/accord.svg";
import Certificate from "../../../assets/certificate.svg";
import Connect from "../../../assets/connect.svg";
import Consent from "../../../assets/consent.svg";
import Cte from "../../../assets/cte.svg";
import Dte from "../../../assets/dte.svg";
import GetData from "../../../assets/getdata.svg";
import Invoice from "../../../assets/invoice.svg";
import Lendbot from "../../../assets/lendbot.svg";
import Vizdata from "../../../assets/vizdata.svg";
import Rules from "../../../assets/rules.svg";
import Sii from "../../../assets/sii.svg";
import Tou from "../../../assets/tou.svg";
import Aec from "../../../assets/aec.svg";
import Dealernet from "../../../assets/dealernet.svg";
import Dj from "../../../assets/dj.svg";
import Empresa from "../../../assets/empresa.svg";
import Equifax from "../../../assets/equifax.svg";
import Fogape from "../../../assets/fogape.svg";
import Jscipher from "../../../assets/jscipher.svg";
import PerfilFinanciero from "../../../assets/perfil-financiero.svg";
import Sbif from "../../../assets/sbif.svg";
import Sinacofi from "../../../assets/sinacofi.svg";
import Tgr from "../../../assets/tgr.svg";
import Signature from "../../../assets/signature.svg";
import AccordTexto from "../../../assets/logo-herramienta/accord-texto.svg";
import ConnectTexto from "../../../assets/logo-herramienta/connect-texto.svg";
import ConsentTexto from "../../../assets/logo-herramienta/consent-texto.svg";
import GetDataTexto from "../../../assets/logo-herramienta/getdata-texto.svg";
import LendbotTexto from "../../../assets/logo-herramienta/lendbot-texto.svg";
import VizdataTexto from "../../../assets/logo-herramienta/vizdata-texto.svg";
import RulesTexto from "../../../assets/logo-herramienta/fleet-texto.svg";
import TouTexto from "../../../assets/logo-herramienta/tou-texto.svg";
import BSHSync from "../../../assets/BSHSync.svg";
import CPESync from "../../../assets/CPESync.svg";
import FACTRACKSYNC from "../../../assets/Factrack.svg";
import RTTSync from "../../../assets/RTTSync.svg";
import DCASync from "../../../assets/DCASync.svg";

export default function DmIcon({ icon, ...props }) {
  switch (icon) {
    case "Accord":
      return <img src={Accord} {...props} />;
    case "Connect":
      return <img src={Connect} {...props} />;
    case "Certificate":
      return <img src={Certificate} {...props} />;
    case "Consent":
      return <img src={Consent} {...props} />;
    case "CTE":
      return <img src={Cte} {...props} />;
    case "DTESync":
      return <img src={Dte} {...props} />;
    case "GetData":
      return <img src={GetData} {...props} />;
    case "Invoice":
      return <img src={Invoice} {...props} />;
    case "Lendbot":
      return <img src={Lendbot} {...props} />;
    case "Vizdata":
      return <img src={Vizdata} {...props} />;
    case "Rules":
      return <img src={Rules} {...props} />;
    case "Sii":
      return <img src={Sii} {...props} />;
    case "AECSync":
      return <img src={Aec} {...props} />;
    case "DEALERNET":
      return <img src={Dealernet} {...props} />;
    case "DJSync":
      return <img src={Dj} {...props} />;
    case "enterprise":
      return <img src={Empresa} {...props} />;
    case "DICOM":
      return <img src={Equifax} {...props} />;
    case "Fogape":
      return <img src={Fogape} {...props} />;
    case "JSCipher":
      return <img src={Jscipher} {...props} />;
    case "PFI":
      return <img src={PerfilFinanciero} {...props} />;
    case "SBIF":
      return <img src={Sbif} {...props} />;
    case "SINACOFI":
      return <img src={Sinacofi} {...props} />;
    case "ToU":
      return <img src={Tou} {...props} />;
    case "TGRSync":
      return <img src={Tgr} {...props} />;
    case "AccordTexto":
      return <img src={AccordTexto} {...props} />;
    case "ConnectTexto":
      return <img src={ConnectTexto} {...props} />;
    case "ConsentTexto":
      return <img src={ConsentTexto} {...props} />;
    case "GetDataTexto":
      return <img src={GetDataTexto} {...props} />;
    case "LendbotTexto":
      return <img src={LendbotTexto} {...props} />;
    case "VizdataTexto":
      return <img src={VizdataTexto} {...props} />;
    case "RulesTexto":
      return <img src={RulesTexto} {...props} />;
    case "TouTexto":
      return <img src={TouTexto} {...props} />;
    case "Signature":
      return <img src={Signature} {...props} />;
    case "BSHSync":
      return <img src={BSHSync} {...props} />;
    case "CPESync":
      return <img src={CPESync} {...props} />;
    case "FACTRACKSYNC":
      return <img src={FACTRACKSYNC} {...props} />;
    case "RTTSync":
      return <img src={RTTSync} {...props} />;
    case "DCASync":
      return <img src={DCASync} {...props} />;
    default:
      return <img src={Tou} {...props} />;
  }
}
